import { getJson } from "../../auth/utils/getJson.js";
import { apiFetch } from "../../auth/api/apiFetch.js";

/** GET /api/dataQuality/filter-directory */
export function fetchFilterDirectory(signal) {
  return getJson("/api/dataQuality/filter-directory", { signal });
}

/** POST /api/configdata */
export async function processConfigBatch(payload, signal) {
  const res = await apiFetch("/api/configdata", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    signal,
  });

  const contentType = (res.headers.get("content-type") || "").toLowerCase();
  const tryJson = async () =>
    contentType.includes("application/json") ? res.json() : null;

  if (!res.ok) {
    const json = await tryJson().catch(() => null);
    const text = json
      ? JSON.stringify(json).slice(0, 300)
      : (await res.text().catch(() => "")).slice(0, 300);
    throw new Error(text || `Failed to process batch (HTTP ${res.status})`);
  }

  const data = await tryJson().catch(() => null);
  return data ?? {};
}
